const BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api/ga`
  : "http://localhost:5000/api/ga";

async function get(path, params = {}) {
  const qs = Object.keys(params).length
    ? "?" + new URLSearchParams(params).toString()
    : "";
  const res = await fetch(`${BASE}${path}${qs}`);
  if (!res.ok) throw new Error(`GA API ${path} → ${res.status}`);
  return res.json();
}

export const analyticsApi = {
  overview:         (p = {}) => get("/overview", p),
  channels:         (p = {}) => get("/channels", p),
  realtime:         ()       => get("/realtime"),
  locations:        (p = {}) => get("/locations", p),
  devices:          (p = {}) => get("/devices", p),
  pages:            (p = {}) => get("/pages", p),
  platform:         (name)   => get(`/platform/${name}`),
  // new routes
  realtimeOverview: ()       => get("/realtime-overview"),
  audience:         (p = {}) => get("/audience", p),
  demographics:     (p = {}) => get("/demographics", p),
  acquisition:      (p = {}) => get("/acquisition", p),
  pagesOverview:    (p = {}) => get("/pages-overview", p),
  events:           ()       => get("/events"),
  weeklyTrend:      ()       => get("/weekly-trend"),
  channelsByDevice: (p = {}) => get("/channels-by-device", p),
  // per-publication routes
  overviewPerPub:    (p = {}) => get("/overview-per-pub", p),
  realtimePerPub:    ()       => get("/realtime-per-pub"),
  channelsPerPub:    (p = {}) => get("/channels-per-pub", p),
  audiencePerPub:    (p = {}) => get("/audience-per-pub", p),
  engagementPerPub:  (p = {}) => get("/engagement-per-pub", p),
  technologyPerPub:  (p = {}) => get("/technology-per-pub", p),
  dailyViewsPerPub:  ()       => get("/daily-views-per-pub"),
  hourlyViewsPerPub: ()       => get("/hourly-views-per-pub"),
};
